import { Link, useSearch } from '@tanstack/react-router';
import { useState, type FormEvent } from 'react';
import { Field } from '../components/page';
import { ActionError } from '../components/states';
import { Button, buttonVariants } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { useApi } from '../lib/auth';
import { useT } from '../lib/i18n';

export function InvitationPage() {
  const t = useT();
  const api = useApi();
  const { token } = useSearch({ strict: false }) as { token?: string };
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<Error | null>(null);
  const [done, setDone] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError(new Error(t.auth.passwordMismatch));
      return;
    }
    try {
      await api.request('POST', '/v1/auth/invitations/accept', { body: { token, password } });
      setDone(true);
    } catch (err) {
      setError(err as Error);
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-sm">
        <CardContent className="flex flex-col gap-4 p-6">
          <h1 className="text-xl font-semibold">{t.auth.invitationTitle}</h1>
          {!token ? (
            <p role="alert" className="text-sm text-destructive">
              {t.auth.missingToken}
            </p>
          ) : done ? (
            <>
              <p role="status" className="text-sm">
                {t.auth.activated}
              </p>
              <Link to="/connexion" className={buttonVariants()}>
                {t.auth.goToLogin}
              </Link>
            </>
          ) : (
            <form onSubmit={(e) => void submit(e)} className="flex flex-col gap-4">
              <p className="text-sm text-muted-foreground">{t.auth.invitationIntro}</p>
              <Field label={t.auth.password} hint={t.auth.passwordPolicy}>
                <Input
                  type="password"
                  autoComplete="new-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Field>
              <Field label={t.auth.passwordConfirm}>
                <Input
                  type="password"
                  autoComplete="new-password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                />
              </Field>
              <ActionError error={error} />
              <Button type="submit">{t.auth.activate}</Button>
            </form>
          )}
        </CardContent>
      </Card>
    </main>
  );
}
